module.exports = "div {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.result-image {\n  margin-left: 10px;\n  text-align: center;\n}\n\n.file-is-over {\n  border: 5px lightgrey;\n  border-style: dashed;\n}\n\n.modal-content{\n  overflow: scroll !important;\n}\n\n@media screen and (max-width: 360px) {\n  .modal-content{\n    max-height: 562px !important;\n  }\n}\n\nmd-progress-spinner {\n  width: 25px !important;\n  height: 25px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/upload-picture-dialog/upload-picture-dialog.css
// module id = ./src/app/dashboard/upload-picture-dialog/upload-picture-dialog.css
// module chunks = main